<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l-3-3l7-7l-7-7l3-3l10,10L0.5,802.5L0.5,802.5z M-4.5,797.5l-5-5l5-5L-3,789l-3.5,3.5L-3,796L-4.5,797.5
	L-4.5,797.5z"/>
</svg>

</template>